import * as React from "react"
import { SVGProps } from "react"

const SvgCog = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.6 -0.6 14 14" {...props}>
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m4.782 2.057.393-1.015a.91.91 0 0 1 .85-.585h.75a.91.91 0 0 1 .85.585l.393 1.015 1.335.768 1.079-.164a.915.915 0 0 1 .914.448l.366.64a.91.91 0 0 1-.073 1.033l-.668.85v1.536l.686.85a.91.91 0 0 1 .073 1.033l-.365.64a.915.915 0 0 1-.915.448l-1.079-.164-1.334.768-.394 1.015a.91.91 0 0 1-.85.585h-.768a.91.91 0 0 1-.85-.585l-.393-1.015-1.335-.768-1.079.164a.91.91 0 0 1-.914-.448l-.366-.64a.91.91 0 0 1 .073-1.033l.668-.85V5.632l-.686-.85a.91.91 0 0 1-.073-1.033l.365-.64a.91.91 0 0 1 .915-.448l1.079.164zM4.572 6.4a1.829 1.829 0 1 0 3.657 0 1.829 1.829 0 0 0-3.658 0"
    />
  </svg>
)
export default SvgCog
